module.exports = __webpack_public_path__ + "static/media/jinbo.46b7c3df.jpg";